module.exports = __webpack_public_path__ + "img/SUPPORT.3bd98cb0.svg";